<template>
  <ItemRow>
    <ItemWithLabel
      :column="columns[0]"
    >
      {{ itemData.nickname }}
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[1]"
    >
      {{ itemData.field1 }}
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[2]"
    >
      {{ itemData.field2 }}
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';

export default {
  name: 'PasswordManagerItemsListRow',

  components: {
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },

    itemData: {
      type: Object,
      required: true,
    },
  },
};
</script>
